<template>
  <div class="mod-overlay" @click.self="$emit('close')">
    <div class="mod-modal">
      <!-- Header -->
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar material' : 'Nuevo material' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Body -->
      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <!-- Error -->
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <!-- Datos generales -->
          <div class="mod-field">
            <label for="Clave">Clave <span class="mod-required">*</span></label>
            <input
              type="text"
              id="Clave"
              v-model="form.Clave"
              :disabled="isEdit"
              required
              maxlength="50"
              placeholder="Codigo del material"
            >
          </div>

          <div class="mod-field">
            <label for="Nombre">Nombre <span class="mod-required">*</span></label>
            <input
              type="text"
              id="Nombre"
              v-model="form.Nombre"
              required
              placeholder="Nombre del material"
            >
          </div>

          <div class="mod-field">
            <label for="Descripcion">Descripción</label>
            <input
              type="text"
              id="Descripcion"
              v-model="form.Descripcion"
              placeholder="Descripción del material"
            >
          </div>

          <div class="mod-field">
            <label for="ClaveErp">Clave ERP</label>
            <input
              type="text"
              id="ClaveErp"
              v-model="form.ClaveErp"
              placeholder="Mapeo con sistema ERP"
            >
          </div>

          <!-- Clasificación -->
          <div class="mod-field">
            <label for="Umedida">Unidad de medida</label>
            <input
              type="text"
              id="Umedida"
              v-model="form.Umedida"
              placeholder="Ej: PZA, KG, LT"
            >
          </div>

          <div class="mod-field">
            <label for="GrupoMaterial">Grupo material</label>
            <input
              type="text"
              id="GrupoMaterial"
              v-model="form.GrupoMaterial"
              placeholder="Grupo o categoría"
            >
          </div>

          <div class="mod-field">
            <label for="TipoArticulo">Tipo artículo</label>
            <input
              type="text"
              id="TipoArticulo"
              v-model="form.TipoArticulo"
              placeholder="Tipo de artículo"
            >
          </div>

          <!-- Precios -->
          <div class="mod-field">
            <label for="UltimoPrecioCompra">Último precio compra</label>
            <input
              type="number"
              id="UltimoPrecioCompra"
              v-model.number="form.UltimoPrecioCompra"
              step="0.01"
              placeholder="0.00"
            >
          </div>

          <div class="mod-field">
            <label for="PrecioPromedio">Precio promedio</label>
            <input
              type="number"
              id="PrecioPromedio"
              v-model.number="form.PrecioPromedio"
              step="0.01"
              placeholder="0.00"
            >
          </div>

          <div class="mod-field">
            <label for="PrecioUltimo">Precio último</label>
            <input
              type="number"
              id="PrecioUltimo"
              v-model.number="form.PrecioUltimo"
              step="0.01"
              placeholder="0.00"
            >
          </div>

          <div class="mod-field">
            <label for="PrecioMinimo">Precio mínimo</label>
            <input
              type="number"
              id="PrecioMinimo"
              v-model.number="form.PrecioMinimo"
              step="0.01"
              placeholder="0.00"
            >
          </div>

          <div class="mod-field">
            <label for="PrecioMaximo">Precio máximo</label>
            <input
              type="number"
              id="PrecioMaximo"
              v-model.number="form.PrecioMaximo"
              step="0.01"
              placeholder="0.00"
            >
          </div>

          <!-- Impuestos -->
          <div class="mod-field">
            <label for="Impuesto1">Impuesto 1</label>
            <input
              type="text"
              id="Impuesto1"
              v-model="form.Impuesto1"
              placeholder="Clave de impuesto"
            >
          </div>

          <div class="mod-field">
            <label for="Impuesto2">Impuesto 2</label>
            <input
              type="text"
              id="Impuesto2"
              v-model="form.Impuesto2"
              placeholder="Clave de impuesto"
            >
          </div>

          <div class="mod-field">
            <label for="Impuesto3">Impuesto 3</label>
            <input
              type="text"
              id="Impuesto3"
              v-model="form.Impuesto3"
              placeholder="Clave de impuesto"
            >
          </div>

          <!-- Cuentas contables -->
          <div class="mod-field">
            <label for="CuentaContable">Cuenta contable</label>
            <input
              type="text"
              id="CuentaContable"
              v-model="form.CuentaContable"
              placeholder="Cuenta contable principal"
            >
          </div>

          <div class="mod-field">
            <label for="CuentaContableCosto">Cuenta contable costo</label>
            <input
              type="text"
              id="CuentaContableCosto"
              v-model="form.CuentaContableCosto"
              placeholder="Cuenta de costo"
            >
          </div>

          <div class="mod-field">
            <label for="CuentaContableVenta">Cuenta contable venta</label>
            <input
              type="text"
              id="CuentaContableVenta"
              v-model="form.CuentaContableVenta"
              placeholder="Cuenta de venta"
            >
          </div>

          <div class="mod-field">
            <label for="CuentaContableGasto">Cuenta contable gasto</label>
            <input
              type="text"
              id="CuentaContableGasto"
              v-model="form.CuentaContableGasto"
              placeholder="Cuenta de gasto"
            >
          </div>

          <!-- Checkboxes -->
          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input type="checkbox" v-model="form.EsInventariable">
              <span>Es inventariable</span>
            </label>
          </div>

          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input type="checkbox" v-model="form.EsDeCompra">
              <span>Es de compra</span>
            </label>
          </div>

          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input type="checkbox" v-model="form.EsDeVenta">
              <span>Es de venta</span>
            </label>
          </div>

          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input type="checkbox" v-model="form.EsActivo">
              <span>Activo</span>
            </label>
          </div>
        </div>

        <!-- Footer -->
        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">
            Cancelar
          </button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear material' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import materialService from './material.service';
import { showToast } from '@/shared/utils/toast';
import authService from '@/services/auth';
import { createMaterial } from './material.model';

export default {
  name: 'MaterialForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createMaterial(),
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;

      if (!this.form.Clave || !this.form.Nombre) {
        this.error = 'Clave y Nombre son obligatorios';
        this.saving = false;
        return;
      }

      try {
        const result = await materialService.guardar(this.form);
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch (e) {
        console.error('Error al guardar:', e);
        this.error = 'Error de conexion con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
</style>
